"use strict";

exports.__esModule = true;
exports.getPieChartDataAggregator = void 0;
var _constants = require("../constants");
//Assuming series is an array of 2 element arrays => 0: timestamp, 1: value

var aggregateSum = function aggregateSum(series) {
  return series.filter(function (s) {
    return s.length === 2;
  }).map(function (s) {
    return s[1];
  }).reduce(function (acc, value) {
    return acc + value;
  }, 0);
};
var aggregateAvg = function aggregateAvg(series) {
  return series.filter(function (s) {
    return s.length === 2;
  }).map(function (s) {
    return s[1];
  }).reduce(function (acc, value) {
    return acc + value;
  }, 0) / series.filter(function (s) {
    return s.length === 2;
  }).length;
};
var aggregateMax = function aggregateMax(series) {
  var filtered = series.filter(function (s) {
    return s.length === 2;
  }).map(function (s) {
    return s[1];
  });
  return filtered.length > 0 ? Math.max.apply(Math, filtered) : null;
};
var aggregateMin = function aggregateMin(series) {
  var filtered = series.filter(function (s) {
    return s.length === 2;
  }).map(function (s) {
    return s[1];
  });
  return filtered.length > 0 ? Math.min.apply(Math, filtered) : null;
};
var getPieChartDataAggregator = exports.getPieChartDataAggregator = function getPieChartDataAggregator(aggrType) {
  switch (aggrType) {
    case _constants.AGGR_SUM:
      return aggregateSum;
    case _constants.AGGR_AVG:
      return aggregateAvg;
    case _constants.AGGR_MAX:
      return aggregateMax;
    case _constants.AGGR_MIN:
      return aggregateMin;
    default:
      return aggregateSum;
  }
};